import Button from "devextreme-react/button";
import {useContext} from "react";
import {EstimateContext} from "../context/EstimateContext";
import {Buffer} from 'buffer';
import {usePrintRetailPrice} from "../api/print-retail-price";
import {showErrorMessage} from "../../../../utils/messages";

export default function PrintRetailPriceButton() {
    const {order} = useContext(EstimateContext);
    const printRetailPrice = usePrintRetailPrice(order.details.quoteID);

    return (
        <Button
            text="Print Retail Price"
            icon="Inscyth-Print"
            disabled={printRetailPrice.isLoading}
            onClick={async () => {
                let reportResult = await printRetailPrice.mutateAsync();
                if (!reportResult.isSuccess) {
                    showErrorMessage(reportResult.errorMessage);
                    return;
                }
                const file = new File(
                    [Buffer.from(reportResult.data, "base64")],
                    order.details.quoteNumber + '-Retail.pdf',
                    {type: 'application/pdf'});

                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }}>
        </Button>
    )
}
